import {
  ACH_METHOD_ICON,
  ACH_METHOD_LIGHT_ICON,
  BANK_TRANSFER_METHOD_ICON,
  BANK_TRANSFER_METHOD_LIGHT_ICON,
  CASH_TRANSFER_UP_METHOD_ICON,
  DEBIT_CARD_METHOD_ICON,
  INTERACT_ICON,
  PAY_ID_ICON,
  PAY_ID_LITE_ICON,
  PAY_NOW_ICON,
  WIRE_TRANSFER_ICON,
  WIRE_TRANSFER_SELECTED_ICON
} from '@Images';
import CHASE_LOGO from '../../assets/us-banks/chase-logo.png';
import BANK_AMERICA_LOGO from '../../assets/us-banks/bank-of-america-logo.png';
import BB_T_LOGO from '../../assets/us-banks/bb-t-logo.png';
import CAPITAL_ONE_LOGO from '../../assets/us-banks/capital-one-logo.png';
import CITI_LOGO from '../../assets/us-banks/citi-logo.png';
import CITIZENS_LOGO from '../../assets/us-banks/citizens-bank-logo.png';
import FIDELITY_LOGO from '../../assets/us-banks/fidelity-logo.png';
import HUNTINGTON_LOGO from '../../assets/us-banks/huntington-logo.png';
import NAVY_FEDERAL_LOGO from '../../assets/us-banks/navy-federal-logo.png';
import PNC_LOGO from '../../assets/us-banks/pnc-logo.png';
import REGIONS_LOGO from '../../assets/us-banks/regions-logo.png';
import SUN_TRUST_LOGO from '../../assets/us-banks/sun-trust-logo.png';
import TD_LOGO from '../../assets/us-banks/td-bank-logo.png';
import USA_A_LOGO from '../../assets/us-banks/usa-a-logo.png';
import US_BANK_LOGO from '../../assets/us-banks/us-bank-logo.png';
import WELLS_FARGO_LOGO from '../../assets/us-banks/wells-fargo-logo.png';
import ACH_DEFAULT_ICON from '../../assets/us-banks/ach-default.png';
export function getPaymentMethodIcon(icon_url, isActive = false) {
  if (!icon_url) icon_url = 'BANK_TRANSFER';
  switch (icon_url) {
    case 'INSTAREM_PAYEE': {
      if (isActive) return BANK_TRANSFER_METHOD_LIGHT_ICON;
      return BANK_TRANSFER_METHOD_ICON;
    }
    case 'WITE_TRANSFER': {
      if (isActive) return WIRE_TRANSFER_SELECTED_ICON;
      return WIRE_TRANSFER_ICON;
    }

    case 'WORLDPAY': {
      if (isActive) return CASH_TRANSFER_UP_METHOD_ICON;
      return DEBIT_CARD_METHOD_ICON;
    }
    case 'ACH': {
      if (isActive) return ACH_METHOD_LIGHT_ICON;
      return ACH_METHOD_ICON;
    }
    case 'PAYNOW': {
      if (isActive) return PAY_NOW_ICON;
      return PAY_NOW_ICON;
    }
    case 'PAYID': {
      if (isActive) return PAY_ID_ICON;
      return PAY_ID_LITE_ICON;
    }

    case 'INTERAC': {
      if (isActive) return INTERACT_ICON;
      return INTERACT_ICON;
    }
    default: {
      if (isActive) return BANK_TRANSFER_METHOD_LIGHT_ICON;
      return BANK_TRANSFER_METHOD_ICON;
    }
  }
}

const usBankIconTemplate = [
  {
    regex: /bank|of|america/gi,
    length: 3,
    file: BANK_AMERICA_LOGO
  },
  {
    regex: /bb/gi,
    length: 1,
    file: BB_T_LOGO
  },
  {
    regex: /capital|one/gi,
    length: 1,
    file: CAPITAL_ONE_LOGO
  },
  {
    regex: /chase/gi,
    length: 1,
    file: CHASE_LOGO
  },
  {
    regex: /citizens|bank/gi,
    length: 2,
    file: CITIZENS_LOGO
  },
  {
    regex: /citi/gi,
    length: 1,
    file: CITI_LOGO
  },
  {
    regex: /fidelity/gi,
    length: 1,
    file: FIDELITY_LOGO
  },
  {
    regex: /huntington/gi,
    length: 1,
    file: HUNTINGTON_LOGO
  },
  {
    regex: /navy|federal/gi,
    length: 2,
    file: NAVY_FEDERAL_LOGO
  },
  {
    regex: /pnc/gi,
    length: 1,
    file: PNC_LOGO
  },
  {
    regex: /regions/gi,
    length: 1,
    file: REGIONS_LOGO
  },
  {
    regex: /sun|trust/gi,
    length: 2,
    file: SUN_TRUST_LOGO
  },
  {
    regex: /td/gi,
    length: 1,
    file: TD_LOGO
  },
  {
    regex: /usa/gi,
    length: 1,
    file: USA_A_LOGO
  },
  {
    regex: /us|bank/gi,
    length: 2,
    file: US_BANK_LOGO
  },
  {
    regex: /wells|fargo/gi,
    length: 2,
    file: WELLS_FARGO_LOGO
  }
];

export function getUSBankIcon(name = '') {
  let selected = usBankIconTemplate.find(({ regex, length }) => {
    let match = name.match(regex);
    return Boolean(match) && match.length === length;
  });
  return selected ? selected.file : ACH_DEFAULT_ICON;
}
